import axios from 'axios';

const axiosInstance = axios.create({
  // PRODUCCION
  baseURL: process.env.REACT_APP_API_URL || 'https://softweb.mx/api',
  // DESAROLLO
  // baseURL: 'http://localhost:5530/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // si usas cookies o auth basada en sesiones
});

export default axiosInstance;
